const {
  callAuthorizedGraphQLEndpoint,
} = require('../../../../../Module/graphQL')

export const createCampaignInternalCodes = queryVars => {
  return callAuthorizedGraphQLEndpoint(
    `mutation ($input: CreateCampaignInternalCodes!) {
      createCampaignInternalCodes(input:$input){
        campaignId
        internalCodes{
          id
          internalCode
          internalLink
          city{
            id
            name
          }
        }
      }
    }`,
    {
      input: queryVars,
    },
  )
}
